module.exports = __webpack_public_path__ + "img/6S.f5e2fc78.png";